export const ADMIN_USER_TYPE = {
  SYSTEM_ADMIN: 'system_admin',
  BANK_ADMIN: 'bank_admin',
  BRANCH_ADMIN: 'branch_admin'
} as const;
